<div
  class="overlay-backdrop"
  role="dialog"
  aria-modal="true"
  (click)="backdropClick($event)"
  (keydown)="keydown($event)"
  tabindex="-1"
>
  <div class="dialog">
    <button #closeBtn class="close" (click)="cancel()" aria-label="Close">
      ×
    </button>
    <h3>Project Colors</h3>

    <div cdkDropList class="list" (cdkDropListDropped)="onDrop($event)">
      <div class="row" *ngFor="let c of colors; let i = index" cdkDrag>
        <div class="drag-handle" cdkDragHandle aria-label="Drag to reorder">
          ⋮⋮
        </div>
        <input
          class="hex"
          [class.invalid]="c.invalid"
          [value]="c.value"
          (input)="onHexInput(i, $event)"
          aria-label="Hex color"
          placeholder="#RRGGBB"
        />
        <input
          class="picker"
          type="color"
          [value]="c.invalid ? '#ffffff' : c.value"
          (input)="onColorPicker(i, $event)"
          aria-label="Color picker"
        />

        <nw-icon type="close" (click)="removeColor(i)" [size]="16"></nw-icon>
      </div>
    </div>

    <div class="actions">
      <button class="add" (click)="addColor()">Add color</button>
      <div class="spacer"></div>
      <button class="cancel" (click)="cancel()">Cancel</button>
      <button class="save" (click)="save()">Save</button>
    </div>
  </div>
</div>
